import { apiWrapper } from '../helper/api-wrapper';

export const getVendorCourier = async () => {
  try {
    const response = await apiWrapper.get('merchants/courier/list');

    return response;
  } catch (error) {
    throw error;
  }
};

export const addCourier = async (payload) => {
  try {
    const response = await apiWrapper.post('merchants/courier/add', payload);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getCourier = async () => {
  try {
    const response = await apiWrapper.get('merchants/shipper/courier/list');

    return response;
  } catch (error) {
    throw error;
  }
};

export const activateAllCouriers = async () => {
  try {
    const response = await apiWrapper.get('merchants/courier/all/check');

    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCourier = async (payload) => {
  try {
    const response = await apiWrapper.delete(
      'merchants/courier/delete',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const editCourier = async (payload) => {
  try {
    const response = await apiWrapper.patch('merchants/courier/edit', payload);

    return response;
  } catch (error) {
    throw error;
  }
};

export const activateCourier = async (payload) => {
  try {
    const response = await apiWrapper.patch(
      'merchants/courier/activattion',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};
